var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tg4-play-icon"},[_c(_setup.IconPlay,{staticClass:"tg4-play-icon-glyph"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }